const _excluded = ["weight", "size", "color", "monospace", "nowrap", "inline"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import 'react';
import styled from 'styled-components';
import { theme } from './styles/theme.js';
import { jsx } from 'react/jsx-runtime';
function Text(_ref) {
  let _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'medium' : _ref$weight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'slateDark' : _ref$color,
    _ref$monospace = _ref.monospace,
    monospace = _ref$monospace === void 0 ? false : _ref$monospace,
    _ref$nowrap = _ref.nowrap,
    nowrap = _ref$nowrap === void 0 ? false : _ref$nowrap,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Font, _objectSpread({
    weight: weight,
    size: size,
    color: color,
    monospace: monospace,
    nowrap: nowrap,
    inline: inline
  }, props));
}
const Font = styled.span.withConfig({
  shouldForwardProp: p => !['nowrap', 'italic', 'center', 'color', 'size', 'weight', 'monospace', 'inline'].includes(p)
})`
  display: ${({
  inline
}) => inline ? 'inline' : 'inline-block'};
  font-family: ${({
  monospace
}) => monospace ? theme.fontFamily.monospace : theme.fontFamily.regular};
  font-weight: ${({
  weight
}) =>
// @ts-expect-error "weight" won't be undefined here because we have default props assigned above
theme.fontWeight[weight]};
  line-height: 1.5;
  font-size: ${({
  size
}) =>
// @ts-expect-error "size" won't be undefined here because we have default props assigned above
theme.fontSize[size]};
  color: ${({
  color
}) => {
  if (color === 'light') return theme.color.textLight;
  if (color === 'accent') return theme.color.textAccent;
  // @ts-expect-error We are trying to index the theme colors which are a limited set by an unlimited set of "string" so TS complains
  if (theme.color[color]) return theme.color[color];
  return theme.color.text;
}};
  ${({
  center
}) => center && `text-align: center;`};
  ${({
  italic
}) => italic && 'font-style: italic'};
  ${({
  nowrap
}) => nowrap && 'white-space: nowrap'};
  word-break: break-all;
  /* stylelint-disable-next-line declaration-property-value-keyword-no-deprecated -- TODO Replace */
  word-break: break-word;
`;
export { Text as default };
//# sourceMappingURL=Text.js.map
